/**
 * CUSTOM.JS OTIMIZADO
 * Seguindo práticas recomendadas do Shopify
 * - Executa apenas em páginas necessárias
 * - JavaScript nativo (sem jQuery)
 * - Cache inteligente para evitar recálculos
 */

(function() {
  'use strict';
  
  // ============================================
  // CONFIGURAÇÕES (ajuste aqui se necessário)
  // ============================================
  const CONFIG = {
    pixDiscount: 5, // 5% de desconto no PIX
    juros: {
      x2: 0, x3: 0, x4: 0, x5: 0, x6: 0,
      x7: 0, x8: 0, x9: 0, x10: 0, x11: 0, x12: 0
    },
    debounceDelay: 150 // ms para aguardar antes de recalcular
  };
  
  // ============================================
  // SCROLL BUTTON (Mobile) - OTIMIZADO
  // ============================================
  function initScrollButton() {
    //  CORREÇÃO #1: Só executa em mobile
    if (!window.matchMedia("(max-width: 768px)").matches) return;
    
    const btn = document.getElementById('scrollToTop');
    if (!btn) return;
    
    let ticking = false;
    
    //  CORREÇÃO #2: requestAnimationFrame (prática Shopify)
    // Evita reflow excessivo e melhora performance
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          const pageOffset = window.pageYOffset || document.documentElement.scrollTop;
          btn.style.display = pageOffset > 1200 ? 'block' : 'none';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true }); // passive: true = melhor performance
  }
  
  // ============================================
  // PARCELAMENTO - OTIMIZADO
  // ============================================
  function initParcelamento() {
    // CORREÇÃO #1: SÓ EXECUTA EM PÁGINAS DE PRODUTO
    // Prática Shopify: verificar template antes de executar
    if (!document.body.classList.contains('template-product')) {
      return; // Sai da função se não for página de produto
    }
    
    // Cache de elementos e valores
    let priceElement = null;
    let lastPrice = null;
    let debounceTimer = null;
    
    /**
     * Calcula e atualiza parcelamento
     * CORREÇÃO #3: Cache inteligente - só recalcula se preço mudou
     */
    function calcularParcelamento() {
      try {
        //CORREÇÃO #2: JavaScript nativo (sem jQuery)
        // querySelector é mais rápido que jQuery
        if (!priceElement) {
          priceElement = document.querySelector(".price--highlight");
        }
        
        if (!priceElement) return;
        
        // Extrai preço do texto
        const priceText = priceElement.textContent;
        const parts = priceText.split('$');
        if (!parts[1]) return;
        
        // Detecta moeda
        const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) 
          ? window.Shopify.currency.active 
          : 'BRL';
        
        let preco, cifrao;
        
        if (currency === "USD") {
          preco = parseFloat(parts[1].trim().replace('.', ','));
          cifrao = "$";
        } else {
          // Remove pontos de milhar e substitui vírgula por ponto
          preco = parseFloat(parts[1].trim().replace(/\./g, '').replace(',', '.'));
          cifrao = "R$";
        }
        
        if (!preco || isNaN(preco)) return;
        
        //CORREÇÃO #3: CACHE - Só recalcula se preço mudou
        // Evita cálculos desnecessários (prática Shopify)
        if (lastPrice === preco) {
          return; // Preço não mudou, não precisa recalcular
        }
        
        lastPrice = preco; // Atualiza cache
        
        // ============================================
        // CÁLCULOS
        // ============================================
        
        // Função auxiliar para formatar preço
        const formatPrice = (value) => value.toFixed(2).replace('.', ',');
        
        // Preços à vista e PIX
        const preco_a_vista = formatPrice(preco);
        const preco_pix = formatPrice(preco - (preco * CONFIG.pixDiscount / 100));
        
        // Calcula todas as parcelas de uma vez
        const parcelas = {};
        for (let i = 2; i <= 12; i++) {
          const total = preco + (preco * CONFIG.juros['x' + i] / 100);
          parcelas[i] = {
            valor: formatPrice(total / i),
            total: formatPrice(total)
          };
        }
        
        // ============================================
        // ATUALIZAÇÃO DO DOM - OTIMIZADA
        // ============================================
        
        //CORREÇÃO #2: JavaScript nativo + requestAnimationFrame
        // Prática Shopify: agrupar mudanças no DOM
        requestAnimationFrame(() => {
          // À vista e Boleto
          const aVistaElements = document.querySelectorAll("#total-a-vista, .total-a-vista");
          aVistaElements.forEach(el => el.textContent = `${cifrao} ${preco_a_vista}`);
          
          const boletoEl = document.getElementById("total-boleto");
          if (boletoEl) boletoEl.textContent = `${cifrao} ${preco_a_vista}`;
          
          // PIX
          const pixEl = document.getElementById("total-pix");
          if (pixEl) pixEl.textContent = `${cifrao} ${preco_pix}`;
          
          const pixValueEl = document.querySelector(".product-pix .pix-value strong");
          if (pixValueEl) pixValueEl.textContent = `${cifrao} ${preco_pix}`;
          
          // Parcelas (2x até 12x)
          for (let i = 2; i <= 12; i++) {
            const parcelaEls = document.querySelectorAll(`.total-${i}x`);
            const totalEls = document.querySelectorAll(`.total-parcelado-${i}x`);
            
            parcelaEls.forEach(el => el.textContent = `${cifrao} ${parcelas[i].valor}`);
            totalEls.forEach(el => el.textContent = `${cifrao} ${parcelas[i].total}`);
          }
        });
        
      } catch(e) {
        console.error('Erro no cálculo de parcelamento:', e);
      }
    }
    
    /**
     * Versão com debounce para eventos de mudança
     * CORREÇÃO #3: Debounce evita cálculos excessivos
     */
    function calcularComDebounce() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(calcularParcelamento, CONFIG.debounceDelay);
    }
    
    // ============================================
    // EVENT LISTENERS - OTIMIZADOS
    // ============================================
    
    //CORREÇÃO #2: JavaScript nativo (sem jQuery)
    // addEventListener é mais eficiente que jQuery .on()
    const variantSelectors = document.querySelectorAll(
      ".block-swatch__radio, .variant-swatch__radio, .product-form__single-selector"
    );
    
    if (variantSelectors.length > 0) {
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', calcularComDebounce);
      });
    }
    
    // Executa cálculo inicial
    calcularParcelamento();
  }
  
  // ============================================
  // INICIALIZAÇÃO
  // ============================================
  
  function init() {
    // Scroll button (mobile)
    initScrollButton();
    
    // Parcelamento (só em produtos)
    initParcelamento();
  }
  
  // Aguarda DOM estar pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
